import React from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { DiscoveryResponse } from '../data';
import { getVersions } from '../versionData';
interface VersionHistoryViewProps {
  row: DiscoveryResponse;
  onBack: () => void;
}
export function VersionHistoryView({
  row,
  onBack
}: VersionHistoryViewProps) {
  const data = getVersions(row.id, row.response, row.party, row.set);
  return <div className="w-full h-full flex flex-col bg-geniac-bg font-sans text-geniac-text" data-id="element-324">
      {/* Header */}
      <div className="flex-shrink-0 px-6 py-4 border-b border-geniac-border bg-geniac-panel/50" data-id="element-325">
        <div className="flex items-center gap-4" data-id="element-326">
          <button onClick={onBack} className="p-2 -ml-2 text-geniac-muted hover:text-geniac-text hover:bg-geniac-hover rounded-md transition-colors" data-id="element-327">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-328" />
          </button>
          <div data-id="element-329">
            <h2 className="text-lg font-semibold text-geniac-text flex items-center gap-2" data-id="element-330">
              {row.type === 'Form Interrogatories' ? 'Form Interrogatory' : row.type === 'Special Interrogatories' ? 'Special Interrogatory' : row.type === 'Requests for Admission' ? 'Request for Admission' : 'Document Request'}{' '}
              {row.number.replace(/^(Form|Special No\.|RFA No\.|Doc Req No\.)\s*/, '')}
              <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-geniac-border text-geniac-muted" data-id="element-331">
                {data.versions.length}{' '}
                {data.versions.length === 1 ? 'Version' : 'Versions'}
              </span>
            </h2>
            <p className="text-sm text-geniac-muted mt-0.5" data-id="element-332">
              {row.party} • {row.set}
            </p>
          </div>
        </div>

        {/* Pinned Question */}
        <div className="mt-4 ml-10 bg-geniac-panel border border-geniac-border rounded-lg px-5 py-4" data-id="element-333">
          <h3 className="text-xs font-semibold uppercase tracking-wider text-geniac-muted mb-2" data-id="element-334">
            Question
          </h3>
          <p className="text-sm leading-relaxed text-geniac-text" data-id="element-335">
            {row.question}
          </p>
        </div>
      </div>

      {/* Side-by-side columns */}
      <div className="flex-1 overflow-x-auto overflow-y-hidden" data-id="element-336">
        <div className="flex gap-5 p-6 h-full min-w-min" data-id="element-337">
          {data.versions.map((version, idx) => {
          const isLatest = idx === data.versions.length - 1;
          return <motion.div key={idx} initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.25,
            delay: idx * 0.08
          }} className={`min-w-[360px] w-[360px] flex-shrink-0 border rounded-lg bg-geniac-panel flex flex-col h-full ${isLatest ? 'border-geniac-accent/50' : 'border-geniac-border'}`} data-id="element-338">
                {/* Column Header */}
                <div className="px-5 py-4 border-b border-geniac-border flex-shrink-0" data-id="element-339">
                  <div className="flex items-center gap-2 mb-1" data-id="element-340">
                    <div className={`w-2.5 h-2.5 rounded-full ${isLatest ? 'bg-geniac-accent' : 'bg-geniac-muted'}`} data-id="element-341" />
                    <h3 className="text-sm font-semibold text-geniac-text" data-id="element-342">
                      {version.label}
                    </h3>
                  </div>
                  <p className="text-xs text-geniac-muted ml-[18px]" data-id="element-343">
                    {version.date}
                  </p>
                  {isLatest && <span className="inline-block mt-2 ml-[18px] px-2 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wider bg-geniac-accent/15 text-geniac-accent" data-id="element-344">
                      Current
                    </span>}
                </div>

                {/* Response Body */}
                <div className="flex-1 overflow-y-auto px-5 py-4" data-id="element-345">
                  <p className="text-sm leading-relaxed text-geniac-text whitespace-pre-wrap" data-id="element-346">
                    {version.text}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </div>;
}